module.exports = __webpack_public_path__ + "static/media/walmart-pdp.adac93b3.png";